const listAttributes = [
  'tutorialId',
  'startDatetime',
  'course',
  'duration',
  'host',
  'description',
  'joinLink',
  'capacity',
  'attendees',
  'linkedTutorials',
] as const;

const getAttributes = [...listAttributes] as const;

export const teacherUpdateAttributes = ['description', 'joinLink', 'capacity'] as const;

export const adminUpdateAttributes = [...teacherUpdateAttributes, 'host', 'attendees'] as const;

export const TutorialAttributes = {
  List: listAttributes,
  Get: getAttributes,
  TeacherUpdate: teacherUpdateAttributes,
  AdminUpdate: adminUpdateAttributes,
};
